import pluralEN from "plural";
import pluralRU from "plural-ru";
import React, { useEffect, useState } from "react";
import { nanoid } from "nanoid";
import { useTranslation } from "react-i18next";
import { useRouteMatch } from "react-router-dom";

import IconYellowAlert from "~/components/Icons/alert-square";
import IconRedAlert from "~/components/Icons/alert-triangle";
import Preloader from "~/components/Preloader";
import Wrapper from "~/shared/ui/Wrapper";
import { dateDifIgnoreWeekends } from "~/libs/dateDifIgnoreWeekends";
import { getFormatDate } from "~/libs/getFormatDate";
import { IconMimeType } from "~/libs/resolveMemeType";
import { useAnnouncement } from "~/pages/Announcement/hooks/useAnnouncement";
import { useAnnouncementGoBack } from "~/pages/Announcement/hooks/useAnnouncementGoBack";

import { ANNOUNCEMENT_OPTIONS_TEXT } from "./options";

import s from "./AnnouncementViewing.less";

const AnnouncementViewing = () => {
  const { t } = useTranslation();
  const language = localStorage.getItem("language");
  const isEn = language === "en";
  const { params } = useRouteMatch();
  const goBack = useAnnouncementGoBack();
  const personalId = params["id"];

  const { announcement: viewingAnnouncement, loading } =
    useAnnouncement(personalId);

  const categoryIco = () => {
    switch (viewingAnnouncement.importance) {
      case "urgent":
        return <IconRedAlert />;
      case "important":
        return <IconYellowAlert />;
    }
  };

  const [dateDedline, setDateDedline] = useState(undefined);

  useEffect(() => {
    if (!!viewingAnnouncement.date) {
      setDateDedline(
        dateDifIgnoreWeekends(new Date(), new Date(viewingAnnouncement.date)) <
          0
          ? 0
          : dateDifIgnoreWeekends(
              new Date(),
              new Date(viewingAnnouncement.date),
            ),
      );
    }
  }, [viewingAnnouncement]);

  const pluralDays = isEn
    ? pluralEN("day", "days", dateDedline)
    : pluralRU(dateDedline, "день", "дня", "дней");

  return (
    <Wrapper.Content
      title={t("announcement.announcement_viewing")}
      txtBtn={t("ui.back")}
      goBackHandler={goBack}
    >
      {loading ? (
        <Preloader />
      ) : (
        <ul className={s.wrapper}>
          <div className={s.wrapper_right}>
            {ANNOUNCEMENT_OPTIONS_TEXT.map((el) => {
              if (el !== "Documents") {
                return (
                  <li key={nanoid()} className={s.item}>
                    <label className={s.item_title}>
                      {t(`announcement.${el}`)}
                    </label>
                    <div className={s.item_description}>
                      {el === "importance" ? (
                        t(`announcement.${viewingAnnouncement[el]}`)
                      ) : el === "date" || el === "createdAt" ? (
                        getFormatDate(viewingAnnouncement[el], true)
                      ) : el === "text" ? (
                        <div
                          className={s.textLoger}
                          dangerouslySetInnerHTML={{
                            __html: viewingAnnouncement[el],
                          }}
                        />
                      ) : el === "createdByUser" ? (
                        viewingAnnouncement[el]?.fullname
                      ) : (
                        viewingAnnouncement[el]
                      )}
                    </div>
                  </li>
                );
              } else {
                return (
                  <li key={nanoid()} className={s.item}>
                    <label className={s.item_title}>
                      {t(`announcement.${el}`)}
                    </label>
                    <div>
                      {viewingAnnouncement[el].map((elemDoc) => {
                        return (
                          <span key={elemDoc.id} className={s.cont}>
                            <a
                              href={elemDoc.link}
                              download
                              target="_blank"
                              placeholder={elemDoc.name}
                              rel="noreferrer"
                            >
                              {IconMimeType(elemDoc)}
                            </a>{" "}
                          </span>
                        );
                      })}
                    </div>
                  </li>
                );
              }
            })}
          </div>
          <div className={s.wrapper_left}>
            <div className={s.info}>
              <div className={s.info__text}>
                <div className={s.fixDeadline}>
                  {t("announcement.createdAt")}:
                  <span>{` ${getFormatDate(
                    viewingAnnouncement["createdAt"],
                    true,
                  )}`}</span>
                </div>
                <div className={s.fixDeadline}>
                  {t("announcement.date")}:
                  <span>{` ${getFormatDate(
                    viewingAnnouncement["date"],
                    true,
                  )}`}</span>
                </div>
                <div className={s.fixDeadline}>
                  {t("violation.timer")}:
                  <span>{` ${dateDedline} ${pluralDays}`}</span>
                </div>
              </div>
              {categoryIco()}
            </div>
          </div>
        </ul>
      )}
    </Wrapper.Content>
  );
};

export default AnnouncementViewing;
